























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { IInventory } from '@/pages/campaign/adset/editingTypes';

@Component
export default class AdsetTableOfLandingURL extends Vue {
    @Prop({ type: Array, required: true })
    readonly value!: IInventory[];

    get targets() { 
        return this.value 
    }
    
    set targets(v: IInventory[]) { 
        this.$emit('input', v) 
    }

    compTerms = compTerms;
    landingURLToApply: string = '';
    trackingURLToApply: string = '';
    rowSelected: IInventory[] = [];
    
    rowSelectedHandler(val: IInventory[]) {
        this.rowSelected = val
    }

    setLandingURLToSelected() {
        const v = this.landingURLToApply;
        this.rowSelected.forEach((item: IInventory) => {
            item.landingURL = v
        });
    }

    setTrackingURLToSelected() {
        const v = this.trackingURLToApply;
        this.rowSelected.forEach((item: IInventory) => {
            item.trackingURL = v
        });
    }
}
